import {
    QueryFunction,
    QueryKey,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events/api/events-api.service';

import { fieldsBookingsQueryKeys } from './price-query-keys';



const { getEventResultPdf } = EventsApiService();

const getEventGalleryQuery = (
    params: any,
    options?: UseQueryOptions<any>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<any>;
    options?: UseQueryOptions<any>;
} => ({
    queryKey: fieldsBookingsQueryKeys.list(params),
    queryFn: ({ signal }) => getEventResultPdf(params, { config: { signal } }),
    ...options,
});

export const useGetEventResultPdf = (
    params: any,
    options?: UseQueryOptions<any>,
) => {
    const { message } = App.useApp();

    return useQuery<any, Error>(
        getEventGalleryQuery(params, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            ...options,
        }),
    );
};



